import { combineReducers } from 'redux';
import report from './report';
import nearby from './nearby';
import buoys from './buoys';
import multiCam from './multiCam';
import featuredContent from './featuredContent';
import details from './details';

export default combineReducers({
  report,
  nearby,
  buoys,
  featuredContent,
  multiCam,
  details,
});
